/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'licensing';
const componentName = 'license-tier-select-card';
const prefix = `${moduleName}.${componentName}`;

export const tierHeader = `${prefix}.tierHeader`;
export const numberOfLicenses = `${prefix}.numberOfLicenses`;
export const cloudLicenses = `${prefix}.cloudLicenses`;
export const cloudLicensesDescription = `${prefix}.cloudLicensesDescription`;
export const onPremLicenses = `${prefix}.onPremLicenses`;
export const onPremLicensesDescription = `${prefix}.onPremLicensesDescription`;

export const ENGLISH = {
    [tierHeader]: '{0}',
    [numberOfLicenses]: '{0} Service Core Licenses',
    [cloudLicenses]: 'Cloud Licensing',
    [cloudLicensesDescription]: 'Enable cloud services licensing to centrally manage licenses, enhance security with role-based access control, and gain real-time insights into license utilization.',
    [onPremLicenses]: 'On-prem License Hub',
    [onPremLicensesDescription]: 'Enable on-premises licensing to manage and validate software licenses within your local network, ensuring compliance and control over your deployed applications.',
};
